import PeopleSerializer from './base';

export default class BulkImport extends PeopleSerializer {
  normalize(_, hash) {
    hash.importData = hash.data;
    delete hash.data;
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    hash.data = hash.importData;
    delete hash.importData;
    return hash;
  }
}
